module.exports = __webpack_public_path__ + "media/evolve/assets/icons/planned/chevron-down-double-small-e5aa3c1ec78ca80add669935a9ac0f69.svg";